import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateOrganizationUserRolesMutation } from "../graphql/mutations";
import type {
  UpdateOrganizationUserRolesMutationType,
  UpdateOrganizationUserRolesMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateOrganizationUserRolesMutation = (
  options?: MutationHookOptions<
    UpdateOrganizationUserRolesMutationType,
    UpdateOrganizationUserRolesMutationVariablesType
  >
) => {
  return useMutation<
    UpdateOrganizationUserRolesMutationType,
    UpdateOrganizationUserRolesMutationVariablesType
  >(UpdateOrganizationUserRolesMutation, options);
};
